import { FC } from "react";

type DescriptionProps = {
  description?: string;
};

const Description: FC<DescriptionProps> = ({ description }) => {
  if (!description) {
    return null;
  }
  return <div className="description" dangerouslySetInnerHTML={{ __html: description }} />;
};

export default Description;
